var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTortendiagrammDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tortendiagramm_Default",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B3CCDD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,20.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.7,35.5c3-3.3,4.9-7.5,5.3-12.2H24.6L36.7,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.7,35.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,20.6H42C41.3,10.6,33.4,2.7,23.4,2V20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.6,23.4V2C10.2,2.7,2,11.4,2,22C2,33,11,42,22,42c4.8,0,9.3-1.7,12.7-4.6L20.6,23.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTortendiagrammDefault);
export default __webpack_public_path__ + "static/media/tortendiagramm-default.5d54c4df9ed92be5d49461cfd733960d.svg";
export { ForwardRef as ReactComponent };